import { render, staticRenderFns } from "./DictCertificateType.vue?vue&type=template&id=ce0ae216&scoped=true&"
import script from "./DictCertificateType.vue?vue&type=script&lang=js&"
export * from "./DictCertificateType.vue?vue&type=script&lang=js&"
import style0 from "./DictCertificateType.vue?vue&type=style&index=0&id=ce0ae216&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce0ae216",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce0ae216')) {
      api.createRecord('ce0ae216', component.options)
    } else {
      api.reload('ce0ae216', component.options)
    }
    module.hot.accept("./DictCertificateType.vue?vue&type=template&id=ce0ae216&scoped=true&", function () {
      api.rerender('ce0ae216', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/DictCertificateType.vue"
export default component.exports